export default __webpack_public_path__ + "static/media/Serverless_in_a_DevOps_World_Serverless_Chats.bf57ed1d.jpg";